module.exports = __webpack_public_path__ + "img/motor-generator.ebb74a32.jpg";